<template>
  <el-dialog
    :title="isCreate ? '新增VIP' : '编辑VIP'"
    :visible="true"
    width="66.666666%"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="VIP名称" prop="vipcardName">
            <el-input
              v-model.trim="ruleForm.vipcardName"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="VIP卡价格(元)" prop="price">
            <el-input v-model.trim="ruleForm.price" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="VIP卡折扣(%)" prop="zhekou">
            <el-input-number
              v-model.trim="ruleForm.zhekou"
              :step="5"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="总限制使用次数" prop="totalLimitCount">
            <el-input
              v-model.trim="ruleForm.totalLimitCount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="每周限制次数" prop="weeklyLimitCount">
            <el-input
              v-model.trim="ruleForm.weeklyLimitCount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="每日限制次数" prop="dailyLimitCount">
            <el-input
              v-model.trim="ruleForm.dailyLimitCount"
              type="text"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="加盟商"
            v-if="userType === 'admin'"
            prop="vendorid"
          >
            <!-- <el-select v-model="ruleForm.vendorid" placeholder="请选择">
              <el-option
                v-for="(item, index) in vendorsList"
                :key="index"
                :label="item.vendorName"
                :value="item.vendorid"
              ></el-option>
            </el-select> -->
            <!-- 参考地址：https://element.eleme.cn/#/zh-CN/component/input -->
            <el-autocomplete
              v-model="ruleForm.vendorName"
              :fetch-suggestions="querySearchVendor"
              placeholder="请输入加盟商"
            ></el-autocomplete>
            {{ ruleForm.vendorid }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品">
            <el-select
              v-model="ruleForm.limitedProductType"
              placeholder="请选择产品"
            >
              <el-option
                v-for="(item, index) in Vip.limitedProductTypeList()"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否有效">
            <el-switch v-model="ruleForm.isEnable"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="门店" prop="shopids">
            <el-select
              v-model="ruleForm.shopids"
              filterable
              multiple
              value-key="shopid"
            >
              <el-option
                v-for="item in shopListForPrompt"
                :key="item.shopid"
                :label="item.value"
                :value="item.shopid"
              ></el-option>
            </el-select>
            <el-checkbox
              v-model="allChecked"
              :disabled="shopListForPrompt.length === 0"
              @change="handleChangeAllChecked"
              >全选</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="使用时长(天)" prop="dayCount">
            <el-input v-model.trim="ruleForm.dayCount" type="text"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否售卖">
            <el-switch v-model="ruleForm.isSell"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="16">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model.trim="ruleForm.remark"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
//import { mapGetters } from "vuex";
import Vip from "../../../plugins/VipClass";
export default {
  props: ["isCreate", "vipItem"],
  data() {
    const vipObj = this.isCreate ? new Vip() : this.vipItem;
    if (!this.isCreate) {
      let list = [];
      if (this.vipItem.shops.length) {
        this.vipItem.shops.forEach(ele => {
          list = list.concat(Object.keys(ele));
        });
        vipObj.shopids = list;
      }
    }
    return {
      //vendorsList: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      //shopList: [],
      ruleForm: {
        vendorName: "",
        ...vipObj
      },
      rules: {
        vipcardName: [{ required: true, message: "请输入VIP名称" }],
        zhekou: [
          { required: true, message: "请输入折扣率百分比" },
          {
            pattern: /^(0|[1-9]\d?|100)$/,
            message: "请输入正确的数字"
          }
        ],
        totalLimitCount: [
          { required: true, message: "请输入限制次数" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的数字"
          }
        ],
        weeklyLimitCount: [
          { required: true, message: "请输入限制次数" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的数字"
          }
        ],
        dailyLimitCount: [
          { required: true, message: "请输入限制次数" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的数字"
          }
        ],
        dayCount: [
          { required: true, message: "请输入限制天数" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "请输入正确的数字"
          }
        ],
        price: [
          { required: true, message: "请输入价格" },
          {
            pattern: /^\d{0,}(\.\d{1,2})?$/,
            message: "请输入正确的数字"
          }
        ],
        vendorid: [{ required: true, message: "请输入加盟商" }],
        shopids: [{ required: true, message: "请输入门店" }],
        remark: [{ required: true, message: "请输入备注" }]
      },
      Vip,
      allChecked: false,
      userType: this.$getUserType()
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$axios(this.$urlMapping[this.isCreate ? "新增VIP" : "更新VIP"], {
            data: {
              id: this.isCreate ? undefined : this.ruleForm.id,
              vipcardid: this.isCreate ? undefined : this.ruleForm.vipcardid,
              vipcardName: this.ruleForm.vipcardName,
              productType: this.ruleForm.productType,
              zhekou: this.ruleForm.zhekou,
              totalLimitCount: this.ruleForm.totalLimitCount,
              weeklyLimitCount: this.ruleForm.weeklyLimitCount,
              dailyLimitCount: this.ruleForm.dailyLimitCount,
              limitedProductType: this.ruleForm.limitedProductType,
              price: this.ruleForm.price,
              isEnable: this.ruleForm.isEnable,
              isSell: this.ruleForm.isSell,
              vendorid: this.ruleForm.vendorid,
              shopids: this.ruleForm.shopids,
              remark: this.ruleForm.remark,
              dayCount: this.ruleForm.dayCount
            }
          }).then(() => {
            this.closeForm();
            this.$emit("refreshData");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    handleChangeAllChecked() {
      if (this.allChecked) {
        this.ruleForm.shopids = this.shopListForPrompt.map(ele => ele.shopid);
      } else {
        this.ruleForm.shopids = [];
      }
    },
    querySearchVendor(queryString, cb) {
      let results = queryString
        ? this.vendorListForPrompt.filter(this.$createFilter(queryString))
        : this.vendorListForPrompt;
      // 调用 callback 返回建议列表的数据
      cb(results);
    }
  },

  watch: {
    "ruleForm.vendorName": {
      handler(newName, oldName) {
        if (newName != oldName) {
          //console.log("vendorName changed" + newName + oldName);
          this.ruleForm.vendorid = this.$getVendorID(newName);

          if (this.ruleForm.vendorid) {
            //this.queryShopForPrompt();
            this.$queryShopForPrompt(this.ruleForm.vendorid, result => {
              this.shopListForPrompt = result;
            });
          } else {
            this.shopListForPrompt = [];
            this.ruleForm.shopids = [];
            //this.$refs["vendor_select"].reset();
          }
        }
      }
    },

    // matchShoplist(val) {
    //   this.allChecked = false;
    //   if (
    //     this.ruleForm.shopids.length > 0 &&
    //     this.ruleForm.shopids.length === val.length
    //   ) {
    //     this.allChecked = true;
    //   }
    // },
    "ruleForm.shopids": {
      handler: function(val) {
        if (val.length === 0 || val.length < this.shopListForPrompt.length) {
          this.allChecked = false;
        }
      }
    }
  },
  mounted() {
    if (this.userType === "admin") {
      this.$queryVendorForPrompt(null, result => {
        this.vendorListForPrompt = result;
      });
    }

    if (!this.isCreate) {
      this.ruleForm.vendorName = this.$getVendorName(this.ruleForm.vendorid);
    }
  }
};
</script>

<style lang="less" scoped></style>
